import CheckedBoxIcon from "../icons/CheckedBoxIcon";
import UncheckedBoxIcon from "../icons/UncheckedBoxIcon";

interface Props {
    fill?: string;
    size?: number;
    checked: boolean;
}

export const SqaureCheckBox: React.FC<Props> = (
    {
        checked,
        fill,
        size
    }
) =>
    checked ? (
        <CheckedBoxIcon fill={fill} width={size} height={size}/>
    ) : (
        <UncheckedBoxIcon fill={fill} width={size} height={size}/>
    );
